import { createMetrics } from 'react-metrics';
import MetricsConfig from './metrics.config';
import { ROUTE_CHANGE, PAGE_CHANGE } from './metricsConstants';

const metrics = createMetrics({
  ...MetricsConfig,
  debug: true,
});

export default function metricsMiddleware({ getState }) {
  return next => action => {
    const returnValue = next(action);
    switch (action.type) {
      case ROUTE_CHANGE:
        const { location } = action;
        const paths = location.pathname.substr(1).split('/');
        const routeState = location;
        metrics.setRouteState(routeState);
        metrics.api.pageView({
          category: !paths[0] ? 'landing' : paths[0],
        });
        break;
      case PAGE_CHANGE:
        metrics.api.track('Page Change Even', {
          data: action.data,
        });
    }
    return returnValue;
  };
}



// WEBPACK FOOTER //
// ./src/metrics/metricsMiddleware.js